<template>
    <div v-if="data" class="company-info__group">
        <div class="company-info__group-title">{{$tCompany('About company')}}</div>
        <div class="company-info__about">
            <div class="company-info__about-translate">
              <TranslateFiled v-model="data.company_information"
                              :label="this.$tEmployer('Description (in free form)')"
                              editor />
            </div>
            <div class="company-info__about-image">
                <span class="company-info__image-title">{{$tEmployer('Company logo')}}</span>
                <div v-if="data.logo" class="company-info__image-wrap">
                    <img :src="data.logo" alt="logo">
                    <button @click="$emit('delete-logo')" class="base-btn base-btn--white delete-btn">
                      <BaseSvg name="ico-close" width="1.2rem" height="1.2rem" />
                    </button>
                </div>
                <div v-else class="company-info__image-wrap">
                  <label class="base-btn base-btn--blue add-company-logo">
                    <input type="file"
                           accept="image/*"
                           @change="$emit('logo-upload', $event)"
                           class="add-company-logo__input"/>
                    <BaseSvg name="ico-plus"
                             width="2rem"
                             height="2rem"
                             class="add-company-logo__icon"/>
                    <span class="add-company-logo__label">{{$tEmployer('Add')}}</span>
                  </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TranslateFiled from "../components/TranslateFiled"
    import employerFormFields from '../mixins/employerFormFields';

    export default {
        name: "EmployerProfileAdditional",
        mixins: [ employerFormFields ],
        components: {
           TranslateFiled
        },
        data() {
            return {
                translateFiledEditor: null
            }
        },
        computed: {},
        methods: {

        }
    }
</script>

<style scoped>

</style>
